import React, { useState, useRef, useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'
import Form from 'react-bootstrap/Form'
import ReactCodeInput from 'react-code-input'
import { connect, useSelector } from 'react-redux'
import { login, sendAccessCode } from '../../../actions/authenticationActions'
import { encodePhone, encodeEmail } from '../../../helpers'
import Message from '../../message'
import ResendCodeLink from './resendCodeLink'
import { useHistory } from 'react-router-dom'
import { Icon } from 'icons'
import { SBText, BText } from 'components/styledComponents/text'
import ReCAPTCHA from 'react-google-recaptcha'

const inputStyle = {
  MozAppearance: 'textfield',
  margin: '2px',
  width: '40px',
  height: '45px',
  fontSize: '1rem',
  lineHeight: '1.5',
  textAlign: 'center',
  border: '2px solid',
  transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
}

const EnterCodeForm = ({
  setCanEnterCode,
  opportunityId,
  option,
  dispatch,
  isAuthenticating,
  mobile,
  email,
  isRequestingAccessCode,
}) => {
  const recaptchaRef = useRef()
  const [accessCode, setAccessCode] = useState('')
  const history = useHistory()
  const handleChange = (value) => {
    setAccessCode(value)
  }
  var isAtSettlement = useSelector((state) => state.user.isAtSettlement)
  const getCaptchaToken = async () => {
    const token = await recaptchaRef.current.executeAsync()
    recaptchaRef.current.reset()
    return await token
  }

  const goBack = () => {
    setCanEnterCode(false)
  }

  const handleLogin = async () => {
    var token = await getCaptchaToken()
    dispatch(login(opportunityId, accessCode, history, token, isAtSettlement))
  }
  const pinInput = useRef()

  const resendCode = async () => {
    var token = await getCaptchaToken()
    dispatch(sendAccessCode(opportunityId, option, token))
    clearAccessCode()
  }

  const clearAccessCode = () => {
    for (let i = 0; i < 6; i++) {
      pinInput.current.state.input[i] = ''
      pinInput.current.textInput[i].value = ''
    }
    setAccessCode('')
  }
  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        handleLogin()
      }
    }
    document.addEventListener('keydown', listener)
    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [accessCode])
  return (
    <Form className="px-5 d-flex flex-column align-items-center">
      <PrimaryButton onClick={goBack} invertColor extendInMob>
        <Icon iconType="BackArrow" />
        <strong className="ml-1">Go back</strong>
      </PrimaryButton>
      <br />
      <Message resendCodeOption={option} resendCodeCallback={resendCode} className="mt-3"/>
      <SBText padded size={2}>
        Enter your verification code
      </SBText>

      <div style={{ textAlign: 'center' }}>
        <p className="mb-0">
          We just sent a verification code to{' '}
          {option === 'mobile' && <span>{mobile}</span>}
          {option === 'email' && <span>{email}</span>}
        </p>
        <p className="mb-4">Enter the code below</p>
        <ReactCodeInput
          className="d-flex mb-4 otp-input justify-content-center"
          type="number"
          fields={6}
          value={accessCode}
          onChange={handleChange}
          inputStyle={inputStyle}
          ref={pinInput}
        />

        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        />

        {isAuthenticating && (
          <PrimaryButton disabled={accessCode.length !== 6}>
            <>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Authenticating...
            </>
          </PrimaryButton>
        )}
        {!isAuthenticating && (
          <PrimaryButton
            disabled={accessCode.length !== 6}
            onClick={handleLogin}
            extendInMob
          >
            Verify code
          </PrimaryButton>
        )}

        <p className="text-smaller mt-3">
          Didn't get it?{' '}
          <a className="link clickable">
            {isRequestingAccessCode ? (
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Resending...
              </>
            ) : (
              <BText onClick={resendCode}>Resend </BText>
            )}
          </a>
        </p>
      </div>
    </Form>
  )
}

function mapStateToProps(state) {
  const { opportunityId } = state.opportunity
  const { isFetching: isAuthenticating } = state.authentication
  const isRequestingAccessCode =
    state.accessCode && state.accessCode.isFetching
      ? state.accessCode.isFetching
      : false
  const { mobile } = state.user
  const { email } = state.user
  return {
    opportunityId,
    isAuthenticating,
    mobile: encodePhone(mobile),
    email: encodeEmail(email),
    isRequestingAccessCode,
  }
}

export default connect(mapStateToProps)(EnterCodeForm)
